// ----------------------------------------------------------------------

export default function BottomNavigationAction(theme) {
  return {
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          ...(process.env?.REACT_APP_TYPE === "free"
            ? {
                "&.Mui-selected": { backgroundColor: "transparent" },
              }
            : {}),
        },
      },
    },
  };
}
